<template>
    <div class="Course" v-show="token">
        <div class="cent" v-show="control">
            <img src="//images.jinku.com/newjk/org/images/course_images/course_icon_03.png" alt="" style="width: 1.18rem;height: 1.18rem;position: absolute;right: 1%;top: 3%;"
                @click="changeWindow(false)">
            <div class="cont clearfix" v-for="course in courseList" @click="toStudy(course.id)" :data-goods_id="course.id" >
                <div class="left">
                    <img :src="course.picture" />
                </div>
                <div class="right">
                    <ul style="list-style: none;" class="text">
                        <li>{{course.name}}</li>
                        <li class="list_s">
                            <p>共{{course.chapter_number}}节</p>
                            <p>{{course.total_duration}}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div style="width: 100%;height: 1rem;line-height: 1rem;font-size: .16rem;text-align: center;margin-bottom:0.8rem"  v-show="page <totalPage" @click="getCourseList">
                点击加载更多...
            </div>
            <div style="width: 100%;height: 1rem;line-height: 1rem;font-size: .16rem;text-align: center;margin-bottom:0.8rem"  v-show="page >=totalPage">
                我是有底线的
            </div>
        </div>


        <div class="content_box" v-show="!control">
            <h1 style="margin-top: .49rem;">级别</h1>
            <div class="list_1">
                <button  v-for="labelTop in labelTopArr" :class="{active:labelTop.id == parentId}" @click="changeParentId(labelTop.id)">
                    <div style="padding-left: .1rem;padding-right: .1rem">{{ labelTop.name }}</div>
                </button>
            </div>
            <h1 v-show="parentId !=0 " >模块</h1>
            <div class="list_2">
                <button v-for="labelSon in labelSonArr" :class="{active:labelSon.id == sonId}" v-show="labelSon.parent_id == parentId" @click="changeSonId(labelSon.id)">
                    <div style="padding-left: .1rem;padding-right: .1rem">{{labelSon.name}}</div>
                </button>
            </div>
            <h1>进度</h1>
            <div class="list_3">
                <button :class="{active:3==isFinish}" @click="changeStatus(3)"><div style="padding-left: .1rem;padding-right: .1rem">全部</div></button>
                <button :class="{active:1==isFinish}" @click="changeStatus(1)"><div style="padding-left: .1rem;padding-right: .1rem">已完成</div></button>
                <button :class="{active:0==isFinish}" @click="changeStatus(0)"><div style="padding-left: .1rem;padding-right: .1rem">未完成</div></button>
            </div>
            <div class="bot" style="position: absolute;left: .32rem;right: .32rem;bottom:0;margin: .5rem auto;margin-bottom: 1.5rem;">
                <button @click="changeWindow(true)">取消</button>
                <button @click="submit">确定</button>
            </div>
        </div>
        <bar></bar>
        <layer></layer>
    </div>
</template>

<script>
    import http from "../lib/http";
    import bar from "./tab-bar/bar.vue";
    import layer from "./tab-bar/layer.vue";

    export default {
        name: 'Course',
        data() {
            return {
                courseList:[],
                control: true ,//控制弹窗显示隐藏
                page:0,
                pageSize:20,
                totalPage:0,
                structureId:0,//默认全部
                isFinish:3,//默认全部
                labelTopArr:[],
                labelSonArr:[],
                parentId:0,
                sonId:0,
                labelTopId:0,
                labelSonId:0,
                token:false
            }
        },
        components:{
            bar,
            layer,
        },
        methods: {
            //显示弹窗
            changeWindow(isShow){
                this.control = isShow;
            },
            getCourseList(){
                this.page++;
                var self = this;
                http({
                    method: "post",
                    url: "/org/course/my-course",
                    data: "page="+this.page+"&page_size="+this.pageSize+"&structure_id="+this.structureId+"&is_finish="+this.isFinish,

                }).then(function(res){
                    if(res.code == 0){
                        self.totalPage = res.data.page.page_total;
                        self.courseList = [].concat(self.courseList,res.data.list);
                    }
                }).catch(function(err){

                });
            },
            getUserInfo(){
                const self = this;
                http({
                    method: "post",
                    url: "/org/user/get",
                    data: ""
                }).then(function(res){
                    if(res.code ==0){
                        self.userLevel = res.data.org_user_level;
                    }
                }).catch(function(err){

                });
            },
            getLabel(){
                var self= this;
                http({
                    method: "post",
                    url: "/org/label/my-course",
                    data: ""
                }).then(function(res){
                    if(res.code==0){
                        self.labelTopArr = res.data.top;
                        self.labelSonArr = res.data.son;
                    }
                }).catch(function(err){

                });
                self.control = true;
            },
            changeParentId(structureId){
                this.parentId = structureId;
                this.sonId=0;
                this.structureId = structureId;
            },
            changeSonId(structureId){
                this.sonId = structureId;
                this.structureId = structureId;
            },
            changeStatus(isFinish){
                this.isFinish=isFinish;
            },
            submit(){
                this.page=0;
                this.courseList = [];
                this.control=true;
                this.getCourseList();
            },
            toStudy(goodsId){
                window.location.href="//m.jinku.com/org/video/?goods_id="+goodsId;
            }

        },
        created() {
            this.getUserInfo();
            this.getLabel();
            this.getCourseList();
            var isToken = document.cookie.split(';');
            if(isToken!=""){
                this.token = true;
            }
        }
    }
</script>

<style scoped>
    .cent {
        overflow-y: auto;
        margin: .3rem .27rem 0 .3rem;
        height: 12rem;
        position: relative;

    }
    .active{
        border: 2px solid #1EC5CF !important;
    }


    .cont {
        width: 100%;
        display: flex;
        margin-bottom: .2rem;
    }

    .left img {
        width: 2.42rem;
        height: 1.35rem;
    }

    .left {
        float: left;
        padding-right: .1rem;
    }

    .right {
        float: right;
        font-size: .26rem;
        flex: 1;
    }

    .list_s {
        display: flex;
        color: #999DAA;
        margin-top: .3rem;
    }

    .list_s p:nth-child(1) {
        margin-right: .2rem;
    }

    .text li:nth-child(1) {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }


    .cent_1 {
        display: flex;
        justify-content: space-between;
    }

    .content_box {
        margin-left: .64rem;
        margin-right: .64rem;
    }

    .list_1,
    .list_2,
    .list_3 {
        width: 100%;
        margin-bottom: .23rem;
    }
    button{
        outline: none;
    }

    .list_1 button:nth-child(4) {
        margin-right: 0;
    }

    .list_2 button:nth-child(4) {
        margin-right: 0;
    }

    .list_1 button,
    .list_2 button,
    .list_3 button {
        display: inline;
        margin-right: .1rem;
        color: #5D7292;
        background: #ECF0F4;
        font-size: .26rem;
        height: .48rem;
        border-radius: .03rem;
        line-height: .48rem;
        text-align: center;
        border: none;
        margin-bottom: .26rem;
    }

    .list_2 {
        border-bottom: .01rem solid #E6E6E6;
    }

    h1 {
        font-size: .28rem;
        margin-bottom: .26rem;
    }

    .bot button {
        width: 3.24rem;
        height: .78rem;
        line-height: .78rem;
        font-size: .28rem;
        border-radius: .03rem;
        border: none;
    }

    .bot button:nth-child(1) {
        margin-right: .2rem;
        border: .01rem solid #127FFC;
        color: #127FFC;
    }

    .bot button:nth-child(2) {
        color: white;
        background: #087AFE;
    }
</style>



// WEBPACK FOOTER //
// src/components/Course.vue